import { i18n } from "../services/i18nService";
import { getGlobalButtonFocusPath, getConfigForModalWithCloseButton } from "../errors/globalButtons";
import { getAppState } from "../state";
import { findFromBrands } from "../helpers/find";
import { CHAMPIONS_TROPHY, CRICLIFE, getIsAnyChildOfParentActive, isBaseContent } from "./tvodUtils";
import { getBrandsName } from "./tvodUtils.js";

import { isSubscriptionActive } from "../utils/subscriptionExtendUtils.js";

const STARZ = "starz";
const STARZPLAY = "starzplay";
export const CREDIT_CARD = "CREDIT_CARD";
export const DEFAULT = "DEFAULT";

export function isChampionsTrophyAddOn(name) {
  // Add Criclife check for business requirements
  // return name === CHAMPIONS_TROPHY;
  return isChampionsTrophyFlow() ? name === CHAMPIONS_TROPHY || name === CRICLIFE : false;
}

export function isChampionsTrophyFlow() {
  const addOnsList = getAppState().subscriptions?.filter(data => data?.name === CHAMPIONS_TROPHY) || [];
  if (addOnsList?.length > 0) {
    return isUserSubscribedToChannel(getAppState().addons, CHAMPIONS_TROPHY) ? false : true;
  }
  return false;
}

export function showChannelSubscriptionErrorPopup(closeModal) {
  const { stateActions, setFocus } = this.props;
  stateActions.showGlobalModal(
    getConfigForModalWithCloseButton(
      {
        text: i18n.get("global.errors.account.channelError")
      },
      closeModal
    )
  );
  setFocus(getGlobalButtonFocusPath("close"));
  return false;
}

export function isAddonContent(name) {
  return name && name !== STARZ && name !== STARZPLAY;
}

export function isMainPackageAddOn(addOnName) {
  return getAddOnByName(addOnName)?.configuration?.isMainPackage || false;
}

export function isStandAloneAddon(addOnName) {
  return getAddOnByName(addOnName)?.configuration?.isStandalone || false;
}

export function getAddOnByName(addOnName) {
  const addOnsList = getAppState().subscriptions?.filter(data => data?.name === addOnName) || [];
  if (addOnsList?.length > 0) {
    return addOnsList[0];
  }
  return null;
}

export function getBrandName(isBrand) {
  if (!isBrand) return "";
  const names = window.location.pathname.split("/");
  return names[2];
}

export function getBrandLogoUrl(brandName, subscriptions) {
  let subscription = findFromBrands(brandName, subscriptions || []);
  let baseSubscription = findFromBrands(brandName, subscription?.brands);
  return subscription?.displayName === STARZPLAY
    ? baseSubscription?.configuration.logoDefaultPNG
    : subscription?.configuration.logoDefaultPNG;
}

export function isStarzPlaySubscription(brandName, subscriptions) {
  let subscription = findFromBrands(brandName, subscriptions || []);
  return subscription?.displayName === STARZPLAY;
}

export function getPaymentPlanOfSubscription(subscription) {
  const mop =
    subscription && subscription.paymentMethods.find(paymentMethod => paymentMethod.paymentType === CREDIT_CARD);
  const paymentPlans = (mop && mop.paymentPlans) || [];
  const paymentPlan = getHighestPaymentPlan(paymentPlans);
  return paymentPlan;
}

export function getHighestPaymentPlan(paymentPlans) {
  let highestPaymentPlan = null;
  paymentPlans.forEach(plan => {
    if (!highestPaymentPlan) {
      highestPaymentPlan = plan;
    } else if (highestPaymentPlan && plan.grossAmount > highestPaymentPlan.grossAmount) {
      highestPaymentPlan = plan;
    }
  });
  return highestPaymentPlan;
}

export function getPaymentPlans(subscription) {
  const mop =
    subscription && subscription.paymentMethods.find(paymentMethod => paymentMethod.paymentType === CREDIT_CARD);
  const paymentPlans = (mop && mop.paymentPlans) || [];
  return paymentPlans;
}

export function isUserSubscribedToChannel(addons = [], name, titleSubscriptionsArr = []) {
  if (isBaseContent(name) && getAppState().userAccountStatus?.toLowerCase() === "active") {
    return true;
  } else if (isAddonContent(name)) {
    const isContentActive = addons.find(addon => addon.name === name && addon.status.toLowerCase() === "active");
    if (isContentActive) {
      return isContentActive;
    }

    let isMultiTagged = false;
    if (titleSubscriptionsArr && titleSubscriptionsArr.length > 0) {
      isMultiTagged = titleSubscriptionsArr.some(subscription => {
        return addons.find(
          addon => addon.name.toLowerCase() === subscription.toLowerCase() && addon.status.toLowerCase() === "active"
        );
      });
      return isMultiTagged;
    } else {
      return isContentActive;
    }
  }
}

export function getSubscriptionNameForModal(addOnData) {
  const {
    applicationState: { country }
  } = this.props;
  const { subscriptionPerCountry, subscription } = addOnData || {};
  let subscriptionName = null;

  if (subscriptionPerCountry) {
    subscriptionName = subscriptionPerCountry[country.toUpperCase()]
      ? subscriptionPerCountry[country.toUpperCase()]
      : subscriptionPerCountry[DEFAULT];
  } else {
    subscriptionName = subscription && subscription.length > 0 ? subscription[0] : null;
  }
  return subscriptionName;
}

export function getInActiveSubscriptionDisplayName(addonName) {
  const {
    applicationState: { addons }
  } = this.props;
  let action = "activate";
  // let subscriptionName = addonName?.parent_slug;
  let subscriptionName = "asiacup2025";
  let subscription = getBrandsName(addons, subscriptionName);
  if (isChampionsTrophyAddOn(subscriptionName)) {
    const isParentActive = isUserSubscribedToChannel(addons, subscription?.name);
    let isAnyChildOfParentActive = !isParentActive ? getIsAnyChildOfParentActive(subscription, addons) : false;
    action = isAnyChildOfParentActive ? "upgrade" : "activate";
  }
  if (subscription) {
    const subscriptionStatus = isSubscriptionActive(addons, subscription.name);
    subscription =
      subscriptionStatus?.status?.toLowerCase() === "active"
        ? getAddOnByName(subscriptionName)
        : getBrandsName(addons, subscriptionName);
  }
  return {
    displayName: subscription?.displayName,
    action
  };
}

export function isAnyAddonStatusActive(addons) {
  if (addons) {
    for (const addon of addons) {
      if (addon?.status?.toLowerCase() === "active") {
        return true;
      }
    }
  }

  return false;
}
